import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { RequestOptions } from './model/request-options';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from '@app/core/loader/service/loader.service';
import { USE_AUTH_HEADER } from '@app/core/interceptors/token.interceptor';

@Injectable({
  providedIn: 'root'
})
export class HttpClientService {

  constructor(
    private http: HttpClient,
    private loaderService: LoaderService
  ) { }

  request(
    method: string,
    url: string,
    body?: any,
    params?: HttpParams | { [param: string]: string | string[] },
    header?: HttpHeaders,
    useAuthHeader: boolean = false  // new auth header flag
  ): Observable<any> {
    let headers = header ?? new HttpHeaders({ 'Content-Type': 'application/json' });

    if (useAuthHeader) {
      // Signal the interceptor to inject Bearer token in Authorization header
      headers = headers.set(USE_AUTH_HEADER, 'true');
    }

    const options: RequestOptions = {
      body,
      headers,
      params
    };

    this.showLoader();

    return this.http.request(method, url, options).pipe(
      catchError(this.handleError),
      finalize(() => this.hideLoader())
    );
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  get(
    url: string,
    header?: HttpHeaders,
    params?: HttpParams,
    useAuthHeader: boolean = false
  ): Observable<any> {
    return this.request('GET', url, null, params, header, useAuthHeader);
  }

  post(
    url: string,
    body: any | null,
    header?: HttpHeaders,
    params?: HttpParams | { [param: string]: string | string[] },
    useAuthHeader: boolean = false
  ): Observable<any> {
    return this.request('POST', url, body, params, header, useAuthHeader);
  }

  put(
    url: string,
    body: any | null,
    header?: HttpHeaders,
    params?: HttpParams | { [param: string]: string | string[] },
    useAuthHeader: boolean = false
  ): Observable<any> {
    return this.request('PUT', url, body, params, header, useAuthHeader);
  }

  delete(
    url: string,
    header?: HttpHeaders,
    params?: HttpParams,
    useAuthHeader: boolean = false
  ): Observable<any> {
    return this.request('DELETE', url, null, params, header, useAuthHeader);
  }

  showLoader() {
    this.loaderService.showLoader();
  }

  hideLoader() {
    this.loaderService.hideLoader();
  }
}